import { Icon } from '@aibees/shared/components';
import { Stack } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { useWhiteLabelContext } from '@aibees/elephant/feature/white-label/context';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { MenuLeftPreviewProps as Props } from './types';

export const MenuLeftPreview = memo(({ className }: Props) => {
  const { headerLogo, primaryColor } = useWhiteLabelContext();

  const logoUrl = headerLogo.value
    ? URL.createObjectURL(headerLogo.value as any)
    : null;

  const color = !primaryColor.error ? primaryColor.value : undefined;

  return (
    <Styled.Wrapper
      className={classnames('MenuLeftPreview', className)}
      title="Menu Left"
    >
      <Stack sx={SX.container(color)}>
        <Stack
          sx={SX.logoContainer}
          justifyContent="center"
          alignItems="center"
        >
          {logoUrl ? (
            <img src={logoUrl} alt="Logo" />
          ) : (
            <Styled.Logo src="/assets/images/ark-logo.svg" alt="logo" />
          )}{' '}
        </Stack>
        <Stack sx={SX.menu} justifyContent="center" alignItems="center">
          <Stack sx={SX.menuIcon} justifyContent="center" alignItems="center">
            <Icon name="home" size={18} />
          </Stack>
        </Stack>
        <Stack sx={SX.menu} justifyContent="center" alignItems="center">
          <Stack sx={SX.menuIcon} justifyContent="center" alignItems="center">
            <Icon name="search" size={18} />
          </Stack>
        </Stack>
        <Stack sx={SX.menu} justifyContent="center" alignItems="center">
          <Stack sx={SX.menuIcon} justifyContent="center" alignItems="center">
            <Icon name="view-in-ar" size={18} />
          </Stack>
        </Stack>
        <Styled.Badge sx={SX.badge(color)}>
          Home
          <Icon name="triangle-left-fill" sxx={SX.icon(color)} />
        </Styled.Badge>
      </Stack>
    </Styled.Wrapper>
  );
});

MenuLeftPreview.displayName = 'MenuLeftPreview';
